export default __webpack_public_path__ + "static/media/pig-sound.446c0010.ogg";